<template>
    <div class="inf_wrap">
        <p class="back_box" @click="back()">
          <img src="../../../static/images/back.png" alt="">
          {{langtrans().fhssyy[languageIndex]}}
          </p>
        <div class="box_req">
            <h2>{{langtrans().hffajb[languageIndex]}}</h2>
            <div class="req_box">
                <b>{{langtrans().jyfa[languageIndex]}}</b>
                <div class="acc_box" >
                    <attaList :attaArr="acc_list"></attaList>
                </div>
            </div>
            <div class="req_box">
                <b>{{langtrans().wdddbj[languageIndex]}}</b>
                <div class="acc_box yellow">
                    <ul>
                    	<li>{{langtrans().ztbtfy[languageIndex]}}<span>{{solution.totalFee}}</span> <span class="text1">{{solution.currency || 'USD'}}</span></li>
                    	<li>{{langtrans().jyfy[languageIndex]}}<span>{{solution.rescueFee}}</span> <span class="text1">{{solution.currency || 'USD'}}</span></li>
                    	<li v-if="$route.query.typeId != 800">{{langtrans().ylfy[languageIndex]}}<span>{{solution.medicFee}}</span> <span class="text1">{{solution.currency || 'USD'}}</span></li>
                    	<li>{{langtrans().ajfy[languageIndex]}}<span>{{solution.caseFee}}</span> <span class="text1">{{solution.currency || 'USD'}}</span></li>
                    </ul>
                </div>
            </div>
            <div class="rescue_box"  v-for="(item,ind) in checkList" :key="ind" v-if="item.list.length != 0">
                <p><b>{{languageIndex == 0 ? item.name : item.nameEn}}</b></p>
                <fuwuqingdan :attaArr=item.list></fuwuqingdan>
            </div >
            <div class="upbtn_box" >
                <el-button type="primary" @click="back()">{{langtrans().gbxqq[languageIndex]}}</el-button>
                <span v-if="flag" @click="toalter">{{langtrans().xgbjjj[languageIndex]}}</span>
                <span v-if="!flag">{{languageIndex == '0'? flagText : flagTextEn}}</span>
            </div>                
           </div>
    </div>
</template>

<script>
import langtrans from "./js/lookinf.vue.trans.js";
import "isomorphic-fetch";
import constants from "@/util/constants.js";
import Promise from 'promise-polyfill';
import attaList from "@/components/attachment/index1";
import fuwuqingdan from "@/components/attachment/qingdan";
if (!window.Promise) {
  window.Promise = Promise;
}
export default {
  data() {
    return {
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data")).data,
      caseid: this.$route.query.caseid,
      thecase: {},
      acc_list: [], // 附件列表 todo
      checkList: [], // 
      flag: true,
      flagText:"",
      flagTextEn:"",
      solution:{},
    };
  },
	components: {
		attaList,
		fuwuqingdan
	},
  methods: {
			langtrans(){
				return langtrans
			},		
    back() {
      this.$router.push("/commonPage/caseindex/offer?typeId="+this.$route.query.typeId);
    },
    toalter() {
      this.$router.push({
        name: "alter",
        params: {          
          token: this.token
        },
        query: {
          caseid: this.caseid,
          typeId:this.$route.query.typeId
        }
      });
    },
    getuploadinfo(){

      let that = this;
      fetch(
        constants.domain+"rescue/case/upload_cnts",
        {
          method: "POST",
          body: `token=${this.token}&objType=2&objId=${this.solution.id}&caseId=${that.$route.query.caseid}`,
          mode: "cors",
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      )
        .then(function(res) {
          //console.log(res);
          return res.json();
        })
        .then(function(data) {
          that.acc_list=data.obj;
					if(that.acc_list.length == 0) return
          that.acc_list.map(v=>{
            if(constants.isPic(v.url)){
              v.icon=v.url;
            }else{
              v.icon='../../../static/images/eles_icon.png';
            }
          })        
        });
    }
  },

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
  mounted() {
    let that = this;
    fetch(
      constants.domain+"rescue/bidding/view_insti_solution",
      {
        method: "POST",
        body: `token=${this.token}&caseId=${this.caseid}`,
        mode: "cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }
    )
      .then(function(res) {
        //console.log(res);
        return res.json();
      })
      .then(function(data) {
        that.solution=data.obj;
        if(data.obj && data.obj.state && data.obj.state != 1){
            that.flag = false;
            if(data.obj.state == 2){
							console.log(that.langtrans().bjycn)
              that.flagText = that.langtrans().bjjjyc[0];
              that.flagTextEn = that.langtrans().bjjjyc[1];
            }else{
               that.flagText = that.langtrans().bjjjyg[0];
               that.flagTextEn = that.langtrans().bjjjyg[1];
            }
        }
        data.obj2.map(v => {
         
          if (v.dict.parentId == "0") {
             console.log("v.dict: 0:"+v.dict.name+" v.dict.id:"+v.dict.id);
            var obj = {};
            obj.id = v.dict.parentId;
            obj.childId = v.dict.id;
            obj.name = v.dict.name;
            obj.nameEn = v.dict.nameEn;
            obj.list = [];
            that.checkList.push(obj);
          } else {
            that.checkList.map(o => {
              if (v.dict.parentId == o.childId) {
                o.list.push(v);
              }
            });
          }
        });
        //获取救援方案
        that.getuploadinfo();
      });
  }
};
</script>

<style scoped>
@import url(../../css/lookinf.css);
.req_box b{font-weight: 600;font-size: 14px;}
.acc_box{margin-left: 30px;}
.yellow {padding: 20px 0;}
.yellow span{color: #ff7200;}
.yellow ul li{text-align: left;}
</style>



// WEBPACK FOOTER //
// src/components/fac/Lookinf.vue